import { useEffect, useState, useContext } from "react";
import { ModalContext } from "hooks/ModalProvider";
import { FiArrowLeft, FiMenu, FiSettings } from "react-icons/fi";
import { DateTime, SideMenu, Info } from "processhub-components-lib";
import { LicenseAgreement } from "processhub-components-lib";
import UserMenu from "../UserMenu";
import { FiX } from "react-icons/fi";
import useScreen from "hooks/useScreen";
import classNames from "utilities/ClassNames";
import { ReactComponent as HealthsensorIcon } from "assets/healthsensorIcon.svg";
import { useMinifiedMenu } from "hooks/useMinifiedMenu";
import { TfiAgenda } from "react-icons/tfi";
import allHooks from "hooks";
import { profileConfig } from "../config/userMenuConfig";
import { navLinks } from "../config/navLinksConfig";
import { useAuth } from "hooks/useAuth";
import HeaderMenu from "./HeaderMenu";
import useApp from "hooks/useApp";
import { useUnityActions } from "hooks/unityActions";
import { getSlideProjectName } from "../config/animations";
import licenseAgreementConfig from "config/license/licenseAgreementConfig";
import ProcessHubLogo from "components/shared/ProgressMonitoringLogo";
import { ReactComponent as ExpoLogo } from "assets/expoLogo.svg";
import { motion } from "framer-motion";
import LicenseDetails from "components/LicenseDetails/LicenseDetails";
import { LicenseDetailsData } from "./domain/types";
import { getLicenseInfo } from "api/license";

export default function Header({ setShowProjects, setShowHealth }: any) {
  const { modalType, setModalType, showKeyGuide, setShowKeyGuide } = useContext(ModalContext);
  const [showSideMenu, setShowMenu] = useState(false);
  const [projectName, setProjectName] = useState('');
  const [settingsShown, setSettingsShown] = useState(false);
  const { isScaled } = useScreen();
  const { logout } = useAuth();
  const authLogout = async () => logout();
  const [showCharacterHasChanged, setShowCharacterHasChanged] = useState(false);
  const { setUser, activeTab } = useApp();
  const [showProfileMenu, setShowProfileMenu] = useState(false);
  const { setIsMovementDisabled } = useUnityActions();
  const is3DDashboard = location.pathname.endsWith("/3d-dashboard");
  const [showLicense, setShowLicense] = useState(false);
  const [showLicenseDetails, setShowLicenseDetails] = useState(false);
  const slideProjectName = getSlideProjectName();
  const [licenseData, setLicenseData] = useState<LicenseDetailsData[]>([]);

  const onLicenseAccept = () => {
    setShowLicense(false);
  };

  const headerMenuButtonsConfig = [{
    title: 'Licence Agreement',
    action: () => setShowLicense(true)
  }];

  const {
    setMinifiedMenuOpen
  } = useMinifiedMenu();

  const genLicenseInfo = async () => {
    const response = await getLicenseInfo();
    if (response.status === 200) {
      console.log(JSON.parse(response.data.jsonString));
      const rawLicenseData = JSON.parse(response.data.jsonString);
      setLicenseData([
        { field: "License Number", value: rawLicenseData?.LicenseNumber || '' },
        { field: "Customer Name", value: 'SDAIA NIC' },
        { field: "Product Name", value: rawLicenseData?.ProductName || '' },
        { field: "License Type", value: rawLicenseData?.LicenseType || '' },
        { field: "No of Licensed Users", value: rawLicenseData?.NoOfLicensedUsers || '' },
        { field: "License Key / Activation Code", value: rawLicenseData?.LicenseKey || '' },
        { field: "Date of Issue", value: rawLicenseData?.DateOfIssue || '' },
        { field: "Date of Expiry", value: rawLicenseData?.DateOfExpiry || '' },
      ]);
    }
  };

  useEffect(() => {
    genLicenseInfo();
  }, []);

  const buttonsConfig = [
    {
      name: '',
      shown: false,
      type: 'icon',
      onClick: () => null,
      Icon: TfiAgenda,
      activeClass: "text-blue",
      inactiveClass: "opacity-75"
    },
    {
      name: 'Settings',
      shown: settingsShown,
      type: 'icon',
      onClick: () => {
        setModalType('settings');
        setMinifiedMenuOpen(false);
      },
      Icon: FiSettings,
      activeClass: "text-blue",
      inactiveClass: "hover:text-blue"
    },
  ];

  const onCharacterConfirm = (name: string) => {
    setShowCharacterHasChanged(true);
    setUser((prev: any) => ({
      ...prev,
      characterName: name
    }));
  };

  useEffect(() => {
    showSideMenu ? setIsMovementDisabled(1) : setIsMovementDisabled(0);
  }, [showSideMenu]);

  return (
    <div className="w-full bg-dark relative z-40">
      <div
        className={classNames(
          "lg:h-12 xl-2xl:h-14 2xl:h-16",
          "mx-auto flex items-center px-3"
        )}
      >
        <div className="relative z-50 flex items-center justify-center gap-5">
          <div
            onClick={() => setShowMenu(!showSideMenu)}
            className="cursor-pointer duration-300"
          >
            {!showSideMenu && <FiMenu size={"30"} className="lg:w-[80%] xl-2xl:w-[90%] 2xl:w-full" />}
            {showSideMenu && <FiArrowLeft size={"30"} className="lg:w-[80%] xl-2xl:w-[90%] 2xl:w-full" />}
          </div>
          <a
            href={'/dashboard'}
            {...(is3DDashboard
              ? { target: "_blank", rel: "noopener noreferrer" }
              : {})}
          >
            <ProcessHubLogo variant="regular" />
          </a>
          <motion.div
            initial={{ marginLeft: 0, opacity: 0 }}
            animate={
              window.innerWidth > 1700
                ? { marginLeft: showSideMenu ? 80 : 0, opacity: 1 }
                : { marginLeft: 0, opacity: 1 }
            }
            transition={{ type: "spring", stiffness: 300, damping: 25 }}
            className={classNames("max-h-10")}
          >
            <a
              href={'/dashboard'}
              {...(is3DDashboard
                ? { target: "_blank", rel: "noopener noreferrer" }
                : {})}
            >
              <ExpoLogo className="max-h-10 object-contain h-10" />
            </a>
          </motion.div>
        </div>
        <div className="flex flex-wrap justify-end grow align-middle items-center">
          <HeaderMenu buttonsConfig={buttonsConfig} />
          <div className="flex items-center mr-4">
            <DateTime hooks={allHooks} />
            <div className="hover:text-blue cursor-pointer w-max mr-6" onClick={() => setShowHealth(true)}>
              <HealthsensorIcon className={classNames(isScaled ? "h-[19px] w-[19px]" : "h-[23px] w-[23px] border-white rounded-full hover:text-blue")} />
            </div>
            <Info setShowKeyGuide={setShowKeyGuide} showKeyGuide={showKeyGuide} hooks={allHooks} />
          </div>
          <UserMenu profileConfig={profileConfig} headerMenuButtons={headerMenuButtonsConfig} hooks={allHooks} logout={authLogout} showProfileMenu={showProfileMenu} setShowProfileMenu={setShowProfileMenu} />
          {
            showLicense &&
            <div className="absolute left-0 top-0 z-50 w-screen h-screen bg-dark/65 flex items-center justify-center align-middle" onClick={() => setShowLicense(false)}>
              <div className="w-[65%] h-[82%] rounded z-50 mt-20 flex flex-wrap mx-auto my-auto relative bg-midnight pb-6 pt-6 2xl:pt-0">
                <LicenseAgreement hasAction={false} onAccept={onLicenseAccept} mode="full" licenseAgreementConfig={licenseAgreementConfig} />
                <div className="absolute rounded top-2 right-0 w-full pr-8 pt-2 pl-12 pb-2 flex justify-end items-center gap-4 bg-midnight">
                  <button className="border-2 p-1 px-3 rounded border-blue" onClick={() => setShowLicenseDetails(true)}>
                    License Details
                  </button>
                  <button
                    className="cursor-pointer bg-blue rounded-md p-1 h-min"
                    onClick={onLicenseAccept}
                  >
                    <FiX size={20} />
                  </button>
                </div>
              </div>
            </div>
          }
          {showLicenseDetails && <LicenseDetails setShowLicenseDetails={setShowLicenseDetails} licenseData={licenseData} />}
          <SideMenu
            closeMenu={() => setShowMenu(false)}
            showSideMenu={showSideMenu}
            navLinks={(scale: any) => navLinks(scale, activeTab?.type)}
            hooks={allHooks}
          />
        </div>
      </div>
    </div>
  );
}